export default __webpack_public_path__ + "images/SO.e06d096.png";